export function audioReducer(audio, action) {
    if (audio === void 0) { audio = null; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'audio') {
                return action.message.payload;
            }
    }
    return audio;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/AudioComponent/reducers.ts
// module id = 1830
// module chunks = 0